module.exports = __webpack_public_path__ + "static/media/hades.c3127e08.jpg";